export enum SiteVariantColorEnum {
  Black = 'Black',
  Blue = 'Blue',
  Brand = 'Brand',
  Green = 'Green',
  White = 'White',
}

export type SiteVariantColorType = keyof typeof SiteVariantColorEnum;
